import { Component, OnInit, Input } from '@angular/core';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';

@Component({
  selector: 'cdk-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() sidenav;
  @Input() sidebar;
  @Input() drawer;
  @Input() matDrawerShow;

  searchOpen: boolean = false;

  toolbarMensagens: any;
  Ambiente: any;
  constructor(private utilServico: UtilServico, private utilDadosLogado: UtilDadosLogado) {}

  ngOnInit() {
    // this.CarregarNotificacoes();
    // setInterval(() => {
    //   this.CarregarNotificacoes();
    // }, 5000);
    // this.Ambiente = '';
    // this.utilServico.Get(`OrigemDados/GetOrigemDadosPorId/${db_config.origem_dado_id}`).subscribe(
    //   result => {
    //     db_config.ambiente_esocial = result[0].ambiente_esocial;
    //     this.Ambiente = result[0].ambiente_esocial == 1 ? 'PRODUÇÃO' : 'HOMOLOGAÇÃO - (TESTES)';
    //   },
    //   error => {}
    // );
    // if (this.Ambiente == '') {
    //   this.utilServico.Get('OrigemDados').subscribe(
    //     result => {
    //       console.log(result[1]);
    //       if (result.length > 1) this.Ambiente = result[1].ambiente_esocial == 1 ? 'PRODUÇÃO' : 'HOMOLOGAÇÃO - (TESTES)';
    //       else this.Ambiente = result[0].ambiente_esocial == 1 ? 'PRODUÇÃO' : 'HOMOLOGAÇÃO - (TESTES)';
    //     },
    //     error => {}
    //   );
    // }
  }

  CarregarNotificacoes(): void {
    this.utilServico.Get(`Notificacao/${this.utilDadosLogado.DadosAcesso().usuario_id}`).subscribe(
      data => {
        this.toolbarMensagens = {
          notificacoes: data
        };
      },
      error => {}
    );
  }
}
